import axios from 'axios'

import { AxiosInterceptor } from '../Config/AxiosInterceptor'

AxiosInterceptor()

export type InvestorKycApplicationsStatus =
  | 'ALL'
  | 'PENDING_APPROVAL'
  | 'APPROVED'
  | 'REJECTED'
  | 'REQUEST_INFO'

const kycServices = {
  index: async (page: number, sortOrder: string, status: string, pageSize?: number) => {
    return await axios.get(
      `investorKycApplications?pageNumber=${page}&sortOrder=${sortOrder}&status=${status}`,
      { params: pageSize ? { pageSize } : undefined },
    )
  },

  listInvestorKycApplications: async (params: {
    pageNumber: number
    pageSize: number
    status: InvestorKycApplicationsStatus
    accountId?: string
    msisdn?: string
  }) => {
    const { pageNumber, pageSize, status, accountId, msisdn } = params
    return await axios.get('investorKycApplications', {
      params: {
        pageNumber,
        pageSize,
        status,
        ...(accountId ? { accountId } : {}),
        ...(msisdn ? { msisdn } : {}),
      },
    })
  },

  getSingle: async (uuid: string | undefined) => {
    return await axios.get(`investorKycApplications/${uuid}`)
  },
  approve: async (uuid: string) => {
    return await axios.put(`investorKycApplications/${uuid}/approve`)
  },
  reject: async (uuid: string) => {
    return await axios.put(`investorKycApplications/${uuid}/reject`)
  },
}
export default kycServices
